import { cn } from '../../lib/utils'

interface PeriodOption {
  value: string
  label: string
}

interface PeriodSelectorProps {
  value: string
  onChange: (v: string) => void
  // Optional override — defaults to the standard 7d/30d/90d/all set.
  // Pages with a retention cap (e.g. Changelog Visits keeps only 90 days
  // of per-visit events) can pass a shorter list to avoid offering
  // periods that can never return data.
  options?: PeriodOption[]
}

const DEFAULT_PERIODS: PeriodOption[] = [
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
  { value: 'all', label: 'All time' },
]

export default function PeriodSelector({ value, onChange, options }: PeriodSelectorProps) {
  const periods = options ?? DEFAULT_PERIODS
  return (
    <div className="inline-flex rounded-lg border border-border p-1 gap-1">
      {periods.map((p) => (
        <button
          key={p.value}
          onClick={() => onChange(p.value)}
          className={cn(
            'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
            value === p.value
              ? 'bg-primary text-primary-foreground'
              : 'bg-secondary hover:bg-secondary/80 text-secondary-foreground'
          )}
        >
          {p.label}
        </button>
      ))}
    </div>
  )
}
